import React, { createContext } from "react"

import { User } from "types/user"

interface UserContextState {
  user: User | undefined
  cid: string | undefined
  setUser: React.Dispatch<React.SetStateAction<User | undefined>>
  setCid: React.Dispatch<React.SetStateAction<string | undefined>>
}

const initialValue: UserContextState = {
  user: undefined,
  cid: undefined,
  setUser: () => {},
  setCid: () => {}
}

export const UserContext = createContext(initialValue)
